import React from "react"

const Error = ({ mensage }) => {
  return (<p className="red darken-4 error">{mensage}</p>)
}

export default Error;